<template>
  <el-dialog
    title="联系我们"
    :visible.sync="dialogFormVisible"
    :width="isMobile == 0 ? '40%' : '90%'"
    @close="closeDialog"
  >
    <el-form
      :model="form"
      label-position="top"
      label-width="80px"
      style="text-align: left"
    >
      <el-form-item
        label="您的需求 :"
        :label-width="formLabelWidth"
        style="margin-bottom: 3px"
      >
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="您的需求场景 :"
        :label-width="formLabelWidth"
        style="margin-bottom: 3px"
      >
        <el-select
          v-model="form.region"
          placeholder="请选择活动区域"
          style="width: 100%"
        >
          <el-option label="小程序" value="shanghai"></el-option>
          <el-option label="网页" value="beijing"></el-option>
          <el-option label="AR" value="beijing"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="您的称呼 :"
        :label-width="formLabelWidth"
        style="margin-bottom: 3px"
      >
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="您目前所在公司或公司官网 :"
        :label-width="formLabelWidth"
        style="margin-bottom: 3px"
      >
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="您的职务 :"
        :label-width="formLabelWidth"
        style="margin-bottom: 3px"
      >
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="您的联系电话 :"
        :label-width="formLabelWidth"
        style="margin-bottom: 3px"
      >
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="您的邮箱 :"
        :label-width="formLabelWidth"
        style="margin-bottom: 3px"
      >
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="您所在的省 :"
        :label-width="formLabelWidth"
        style="margin-bottom: 3px"
      >
        <el-select
          v-model="form.region"
          placeholder="请选择活动区域"
          style="width: 100%"
        >
          <el-option label="区域一" value="shanghai"></el-option>
          <el-option label="区域二" value="beijing"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="活动形式" prop="desc" style="margin-bottom: 3px">
        <el-input
          type="textarea"
          v-model="form.desc"
          rows="8"
          resize="none"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="canleFrom">取 消</el-button>
      <el-button type="primary" @click="comfirmFrom">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["dialogFormVisible"],
  data() {
    return {
      gridData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
      ],
      dialogTableVisible: false,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      formLabelWidth: "120px",
      isMobile: 0,
    };
  },
  created() {
    this.handleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.handleResize);

    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    canleFrom() {
      this.$emit("returnCall", false);
    },
    comfirmFrom() {
      this.$emit("returnCall", true);
    },
    closeDialog() {
      this.$emit("returnCall", false);
    },
    handleResize() {
      console.log(document.body.clientWidth);

      if (document.body.clientWidth > 550) {
        this.isMobile = 0;
      } else {
        this.isMobile = 1;
      }
    },
  },
};
</script>

<style lang="less"></style>
